import React from "react";
import { TabList, Tab, Tabs, Box } from "@chakra-ui/react";
import { TabsProps } from "../../utils/types/prop.tab";
import { color } from "../../utils/theme";

const NavigationTabs = ({ tabs }: { tabs: TabsProps[] }) => {
  return (
    <Box
      w={"100%"}
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"flex-start"}
      alignContent={"center"}
      alignItems={"center"}
    >
      <Tabs
        defaultIndex={tabs.findIndex((tab) => tab.activeLink)}
        isFitted
        variant={"enclosed"}
        colorScheme="blue"
        _activeLink={{ fontWeight: "bold" }}
        w={["100%"]}
      >
        <TabList
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          alignContent={"center"}
          alignItems={"center"}
        >
          {tabs.map((tab, index) => (
            <Tab
            sx={
                tab.activeLink
                ? { color: color.primary, fontWeight: "bold", transition: "transform 0.3s" }
                : { fontWeight: "semi-bold", transition: "transform 0.3s" }
            }
              key={index}
              onClick={() => {
                tab.onClick();
              }}
            >
              {tab.title}
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </Box>
  );
};

export default NavigationTabs;
